/* eslint quotes: ["error", "single"] */
/* eslint quote-props: ["error", "always"] */
module.exports = {
  'Hello': 'Olá'
};
